import type { ApiClient } from '../client'
import type {
  ConversationThread,
  ListThreadsQuery,
  ReplyRequest,
  SimulatorOutcome,
  SimulatorRunRequest,
  ThreadDetail,
} from '../types'

/** src/modules/conversations/controllers/conversations.controller.ts */
export function conversationsEndpoints(api: ApiClient) {
  return {
    /** `{ data: { items } }` — no cursor, no location filter (see the inbox note). */
    list: (query: ListThreadsQuery = {}) =>
      api.getItems<ConversationThread>('conversations', { query: { ...query } }),
    get: (id: string) => api.get<ThreadDetail>(`conversations/${id}`),
    /** 202 — the message is queued; the worker decides whether it is ever sent. */
    reply: (id: string, body: ReplyRequest) =>
      api.post<{ readonly outreach_message_id: string }>(`conversations/${id}/reply`, body),
    escalate: (id: string) => api.post<ConversationThread>(`conversations/${id}/escalate`),
    resolve: (id: string) => api.post<ConversationThread>(`conversations/${id}/resolve`),
    /** The guardrail simulator. Every row it writes is `is_sandbox = true`. */
    simulate: (body: SimulatorRunRequest) =>
      api.post<SimulatorOutcome>('conversations/simulator/run', body),
  }
}
